import { useMutation } from "@tanstack/react-query";
import { checkEmail } from "../../apis";

export function useEmailCheck() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: (email: string) => {
      return checkEmail(email);
    },
  });
  return {
    checkEmail: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
